import React from 'react';
import '../../assets/sass/bootstrap.scss';
import '../../assets/sass/style.scss';
// import '../../assets/sass/_bootstrap-compass.scss';
// import '../../assets/sass/_bootstrap-mincer.scss';
// import '../../assets/sass/_bootstrap-sprockets.scss';

export const OurStoryPage = () => {
  return (
    <>
      <div id="fh5co-when-where" className="fh5co-section-gray">
        <div className="container">
          <div className="row row-bottom-padded-md">
            <div className="col-md-12 text-center animate-box">
              <div className="wedding-events">
                <div className="ceremony-bg" style={{ backgroundImage: 'url(images/max-claire-roof.jpg)' }}></div>
                <div className="desc">
                  <h3>A classic set up! </h3>
                  <p>
                    Thea and JG invited us both to a brunch in early February 2020… Max brought a date. And the rest was
                    history! Not quite, but after a few more rom-com worthy mishaps, a ski trip to Dorset, Vermont, a
                    very earnest Google doc, and Max hosting a onesie/90s night party - our destiny was set!
                  </p>
                  <p>
                    Then pandemic hit and we were incredibly thankful to have each other. Claire was in her first year
                    of fellowship which came with the most intense hospital schedule on top of the intensity and
                    uncertainty added by being in NYC at the beginning of Covid. Max worked from his small bedroom then
                    would bike up to Claire&apos;s studio in the Upper West Side to hang out when Claire would finish
                    her shifts. We cooked lots of dinners, had lots of outdoor park-hangs and take-away food, and
                    continued to hang with Thea and JG (and Buddy).
                  </p>
                  <p>
                    Things continued to go well together and we moved in to the coolest NYC apartment in the Summer of
                    2021.
                  </p>
                  <p>
                    Max proposed on the roof of the building during sunset, and hosting an anniversary onesie/90s night
                    party with some surprise guests for Claire!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
